import './PriceDescriptions.scss';
import React from 'react';

function PriceDescriptions({data,total}) {
  let priceDescriptionItem = data.map((item,index) =>(
    <div className='price-description-item' key={index}>{item}</div> 
))
  return (
    <div className="price-card">
      <div className="price-card-content">
        <div className="price-description-data">
          <div className="price-description-items">
              {priceDescriptionItem}
          </div>
        </div>
        <div className="total">
            {total}
        </div>
      </div>
    </div>
  );
}

export default PriceDescriptions;